import _ from 'underscore';
import { IntlShape } from 'react-intl';

interface FormFields {
  name: string;
  min: number;
  max: number;
  value: string;
  nutrientNumber: string;
}

const PAGE_NAME_ID = 'feedManagement.editManualFeed.calculateNutrients.list';

export const fieldList = (intl: IntlShape) => {
  const formFields: FormFields[] = [
    {
      name: intl.formatMessage({ id: `${PAGE_NAME_ID}.arginine` }),
      nutrientNumber: 'N226',
      value: 'arginine',
      min: 1,
      max: 5,
    },
    {
      name: intl.formatMessage({ id: `${PAGE_NAME_ID}.histidine` }),
      nutrientNumber: 'N228',
      value: 'histidine',
      min: 0.25,
      max: 3,
    },
    {
      name: intl.formatMessage({ id: `${PAGE_NAME_ID}.isoleucine` }),
      nutrientNumber: 'N225',
      value: 'isoleucine',
      min: 0.5,
      max: 5,
    },
    {
      name: intl.formatMessage({ id: `${PAGE_NAME_ID}.leucine` }),
      nutrientNumber: 'N229',
      value: 'leucine',
      min: 1,
      max: 5,
    },
    {
      name: intl.formatMessage({ id: `${PAGE_NAME_ID}.lysine` }),
      nutrientNumber: 'N220',
      value: 'lysine',
      min: 1,
      max: 5,
    },
    {
      name: intl.formatMessage({ id: `${PAGE_NAME_ID}.methionine` }),
      nutrientNumber: 'N221',
      value: 'methionine',
      min: 0.5,
      max: 3,
    },
    {
      name: intl.formatMessage({ id: `${PAGE_NAME_ID}.phenylalanineTyrosine` }),
      nutrientNumber: 'N237',
      value: 'phenylalanineAndTyrosine',
      min: 0.5,
      max: 5,
    },
    {
      name: intl.formatMessage({ id: `${PAGE_NAME_ID}.threonine` }),
      nutrientNumber: 'N223',
      value: 'threonine',
      min: 0.5,
      max: 5,
    },
    {
      name: intl.formatMessage({ id: `${PAGE_NAME_ID}.tryptophan` }),
      nutrientNumber: 'N224',
      value: 'tryptophan',
      min: 0.1,
      max: 3,
    },
    {
      name: intl.formatMessage({ id: `${PAGE_NAME_ID}.valine` }),
      nutrientNumber: 'N231',
      value: 'valine',
      min: 0.5,
      max: 5,
    },
    {
      name: intl.formatMessage({ id: `${PAGE_NAME_ID}.methionineCysteine` }),
      nutrientNumber: 'N236',
      value: 'methionineAndCysteine',
      min: 0.5,
      max: 3,
    },
    {
      name: intl.formatMessage({ id: `${PAGE_NAME_ID}.protein` }),
      nutrientNumber: 'N113',
      value: 'protein',
      min: 200,
      max: 500,
    },
  ];

  return _.chain(formFields).sortBy('nutrientNumber').value();
};
